export default __webpack_public_path__ + "static/1-0f01fa8c5b88b0cc322aa601e5ca305a.jpeg";